// extracted by mini-css-extract-plugin
module.exports = {"container":"e_go","floatingBox":"e_ho","floatingAd":"e_io"};